<template>
  <div class="section">
    <div class="container">
      <!-- <div class="container" v-if="dataList.lenght > 0"> -->
      <h1 class="title ">ກວດສອບຄົນເຂົ້າງານ</h1>
      <div class="columns red24bold" v-if="!checkEventName">

          ບໍ່ພົບຂໍ້ມູນ


      </div>
      <div class="columns" v-else-if="checkEventName && activeEventCount ==1">
        <div class="column">
          <div class="columns" >
            <div class="column">
              <b-field style="background-color: #039BE5; padding: 5px 5px 5px 5px; color: white; font-size: 20px;">
                <span   style="margin-right: 10px;">{{ activeEventName }}  </span>
              </b-field>

              <!-- <b-field style="background-color: #039BE5; padding: 5px 5px 5px 5px; color: white; font-size: 20px;">
                <span   style="margin-right: 10px;">ງານປະຈຸບັນ: </span><span  >{{ checkRootEventID }} -- {{ activeEventID }} </span>
              </b-field>
              <b-field style="background-color: #039BE5; padding: 5px 5px 5px 5px; color: white; font-size: 20px;">
                <span   style="margin-right: 10px;">ງານປະຈຸບັນ: </span><span  >{{ activeRootRegno }} -- {{ checkRegNo }} </span>
              </b-field> -->
              
              <b-field>
                <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ລົງທະບຽນມາໃນຊື່ງານ: </span><span  class="red16">{{ checkEventName }} </span>
                </b-field>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ລະຫັດລົງທະບຽນ: </span><span  class="red16">{{ checkRegNo }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span><span  class="red16">{{ checkFullname }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ອາຍຸ: </span><span   style="margin-right: 5px;" class="red16">{{ checkAgeTitle }} </span> 
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ເພດ: </span><span  class="red16">{{ checkGenderTitle }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ກຸ່ມເຂົ້າຮ່ວມ: </span><span  class="red16">{{ checkSectionName }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ພາກສ່ວນ: </span><span  class="red16">{{ checkOrganization }}</span> <span  class="title16-light" style="margin-left: 20px; margin-right: 10px;"> ຕຳແໜ່ງ: </span><span  class="red16"> {{ checkPosition }}</span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ຫົວຂໍ້ທີ່ສົນໃຈ: </span><span  class="red16">{{ checkInterestedTitle }}</span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ເບີໂທ: </span><span  class="red16">{{ checkPhoneNo }}</span>
              </b-field>

              <!-- start dispaly not pay status -->
              <b-field v-if="participateStatus == 1 && isPay" class="red16bold"> 
                 ຍັງບໍ່ທັນຢືນຢັນເຂົ້າຮ່ວມງານ
              </b-field>          

              <b-field v-if="participateStatus == 3 " class="red16bold"> 
                ✅ເຂົ້າງານແລ້ວ
              </b-field>
              <b-field v-if=" participateStatus == 3 " > 
                ເຂົ້າງານເມື່ອ: {{ this.txdateenter }}
              </b-field>
              <!-- end dispaly not pay status -->

              <!-- start dispaly pay status -->
              <!-- <b-field v-if="isPay==1 && payStatus== null" class="red16bold"> 
                 ຍັງບໍ່ທັນຢືນຢັນການຊຳລະ
              </b-field> -->

              <!-- <b-field v-else-if="isPay==1 && payStatus== 0" class="red16bold"> 
                ❌ ຕອບບໍ່ເຂົ້າຮ່ວມ -- {{isPay}} -- {{ payStatus }}
              </b-field> -->

              <!-- <b-field v-if=" isPay==1 && (participateStatus == 3 || participateStatus == 2) " class="red16bold"> 
              ✅ ຊຳລະແລ້ວ
              </b-field> -->
              
              <!-- <b-field v-if="isPay==1 && participateStatus == 3 " class="red16bold"> 
                ✅ ເຂົ້າງານແລ້ວ
              </b-field>
              <b-field v-if="isPay==1 && participateStatus == 3 " > 
                ເຂົ້າງານເມື່ອ: {{ this.txdateenter }}
              </b-field> -->
              <!-- end dispaly pay status -->

              

              <b-field v-if="participateStatus !=3 && (activeRootRegno != checkRegNo )" class="red16bold"> 
                <div class="columns" >
                  <div class="column">
                    <b-field label="">
                      <Multiselect     
                        placeholder="ຈຳນວນ(ຖ້າມີ)"
                        v-model.trim="selectedFollower"
                        label="NAME"
                        track-by="ID"
                        :options="followerList"   
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-input
                      placeholder="ລະຫັດຜູ້ກວດສອບ"
                      v-model.trim="approveCode"
                      type="password"
                    >  
                    </b-input>
                  </div>
                  <div class="column">
                    <b-button class="btn-group-margin is-fullwidth" style="margin-top: 0px;"
                        type="is-danger"  
                        @click="checkParticipate(data)"
                        >  <span >ກວດສອບຂໍ້ມູນ</span>
                    </b-button>
                  </div>
                </div>
                  
              </b-field>
              

             
            </div>
          
          </div>

          
          
        </div>
          
        <div class="column">
          
        </div>
        
          
      </div>
      <div class="columns red16bold" v-else>
        ແຈ້ງຜູ້ຄຸ້ມຄອງລະບົບໃຫ້ Active ງານກ່ອນ
      </div>
    </div>
  </div>
</template>

<script>

import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  
  name: "home",
  props: {
    regno: {
      type: String,
      required: false, // Make it optional to support both routes
    },
  },

  data() {
    return {
      username: null,
      activeEventCount: null,
      activeEventID: null,
      activeEventName: null,
      checkRegNo: null,
      checkEventID: null,
      checkEventName: null,
      checkFullname: null,
      checkAgeTitle: null,
      checkAgeID: null,
      checkGenderTitle: null,
      checkGenderID: null,
      checkPhoneNo: null,
      checkSelfRegister: null,
      checkSectionName: null,
      checkSectionID: null,
      checkInterestedID: null,
      checkInterestedTitle: null,
      checkOrganization: null,
      checkPosition: null,
      checkRootEventID: null,
      activeRootRegno: null,

      participateStatus: null,
      payStatus: null,
      isPay: null,

      txdateconfirm: null,
      txdateenter: null,

      approveCode: null,

      dataList: [],

      selectedFollower: null,
      followerList: [
        {ID: 1, NAME: 'ຜູ້ຕິດຕາມ 1'},
        {ID: 2, NAME: 'ຜູ້ຕິດຕາມ 2'},
        {ID: 3, NAME: 'ຜູ້ຕິດຕາມ 3'},
        {ID: 4, NAME: 'ຜູ້ຕິດຕາມ 4'},
        {ID: 5, NAME: 'ຜູ້ຕິດຕາມ 5'},
        {ID: 6, NAME: 'ຜູ້ຕິດຕາມ 6'},
        {ID: 7, NAME: 'ຜູ້ຕິດຕາມ 7'},
        {ID: 8, NAME: 'ຜູ້ຕິດຕາມ 8'},
        {ID: 9, NAME: 'ຜູ້ຕິດຕາມ 9'},
        {ID: 10, NAME: 'ຜູ້ຕິດຕາມ 10'},
      ],



    };
     
    
  },
  methods: {   
    checkParticipate(){
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,  
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        }).then((result) => {
        if (result.value) {

          const loadingComponent = this.$loading.open({});   
          var params = {
            regno: this.regno,  
            eventid: this.checkEventID,  
            activeeventid: this.activeEventID,
            fullname: this.checkFullname,
            position: this.checkPosition,
            organization: this.checkOrganization,
            age: this.checkAgeID,
            gender: this.checkGenderID,
            section: this.checkSectionID,
            interested: this.checkInterestedID,
            phoneno: this.checkPhoneNo,
            self: this.checkSelfRegister,
            follower: this.selectedFollower ? this.selectedFollower.ID : 0,
            approvecode:  this.sha2(this.approveCode),

          };
          // console.log("params: " + JSON.stringify(params))
          RestAPI.checkEventParticipate(params)
            .then((res) => {
              loadingComponent.close();
              if(res.data.responseData.data==='approvecode is not correct'){
                this.$swal("approvecode ບໍ່ຖືກຕ້ອງ", "-", "error");
                return false;
              }

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.getData();

          

            })
            .catch((error) => {
              console.log(error);
              this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
            });
        }
      });
        
    },
  

    getData(){
      var params = {
        regno: this.regno,  
      };
      RestAPI.getDataByRegNo(params)
        .then((res) => {
          if(res.data.responseData.data==='cannot get data'){
            this.$swal("ບໍ່ພົບຂໍ້ມູນ", "-", "error");
            return false;
          }

          this.activeEventID = res.data.responseData.data.active.EVENTID;
          this.activeEventName = res.data.responseData.data.active.EVENTNAME;
          this.activeRootRegno = res.data.responseData.data.active.ROOTREGNO;
          this.participateStatus = res.data.responseData.data.active.STATUS;
          this.txdateenter= res.data.responseData.data.active.TXDATEENTER;

          this.activeEventCount = res.data.responseData.data.count.EVENTCOUNT;

          this.checkRegNo = res.data.responseData.data.reg.REGNO;
          this.checkEventID = res.data.responseData.data.reg.EVENTID;
          this.checkEventName = res.data.responseData.data.reg.EVENTNAME;
          this.checkFullname = res.data.responseData.data.reg.FULLNAME;
          this.checkAgeTitle = res.data.responseData.data.reg.AGETITLE;
          this.checkAgeID = res.data.responseData.data.reg.AGEID;
          this.checkGenderID = res.data.responseData.data.reg.GENDERID;
          this.checkGenderTitle = res.data.responseData.data.reg.GENDERTITLE;
          this.checkSectionName = res.data.responseData.data.reg.SECTIONNAME;
          this.checkSectionID = res.data.responseData.data.reg.SECTIONID;
          this.checkInterestedID = res.data.responseData.data.reg.INTERESTEDID;
          this.checkInterestedTitle = res.data.responseData.data.reg.INTERESTEDTITLE;
          this.checkPhoneNo = res.data.responseData.data.reg.PHONENO;
          this.checkSelfRegister = res.data.responseData.data.reg.SELFREGISTER;
          
          this.payStatus = res.data.responseData.data.reg.PAYSTATUS;
          this.isPay = res.data.responseData.data.reg.ISPAY;
          
          this.checkOrganization = res.data.responseData.data.reg.ORGANIZATION;
          this.checkPosition = res.data.responseData.data.reg.POSITION;
          this.checkRootEventID = res.data.responseData.data.reg.ROOTEVENTID;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },  

  },
  

  mounted() {

    this.getData();
  
  }
};
</script>
<style lang="css" scoped>

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red24bold{
  color: red;
  font-size: 24px;
  font-weight: bold;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}

</style>
